import { convertToRules } from '@/utils/validate'
import _ from 'lodash'
export default {
  inject: ['tableRoot'],
  props: {
    prop: {
      type: String,
      default: null,
    },
    column: {
      type: Object,
      default: () => {},
    },
    config: {
      type: Object,
      default: () => {},
    },
    row: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    explainValidate() {
      if (this.config.validate) {
        //解析 validate
        let rules = _.concat(
          this.config.rules || [],
          convertToRules(
            this.config.validate,
            '',
            this.config.type ?? 'string',
            this.config.trigger ?? ['change', 'blur']
          )
        )
        return rules
      }
    },
  },
}
